<template>
	<div class="navbar">
		<nav>
			<h1>
				<img class="logoNamSan">
				<a href='#'>{{ $t('label.titleWebPage') }}</a>
				<div class="align-icon">
					<a class="fa fa-facebook" href='https://www.facebook.com/angelmiguel.almendrodelaiglesia.3' target="_blank"></a>
					<a class="fa fa-twitter" href='https://twitter.com/taekwondonamsan?lang=es' target="_blank"></a>
					<a class="fa fa-instagram" href='https://www.instagram.com/taekwondonamsan/?hl=es' target="_blank"></a>
				</div>
			</h1>
			<ul>
				<li v-for="(menuItem,index) in menuOptions" :key="menuItem[index]">
					<router-link :to="`${menuItem.route}`" @click.native="closeNavBar">{{ $t(`label.${menuItem.label}`) }}</router-link>
				</li>
			</ul>
			<div style="clear: both"></div>
		</nav>
		<div class="responsive-bar">
			<h2>
				<img class="logoNamSan">
				<a href='#'>{{ $t('label.titleMobile') }}</a>
				<div class="align-icon">
					<a class="fa fa-facebook" href='https://www.facebook.com/angelmiguel.almendrodelaiglesia.3' target="_blank"></a>
					<a class="fa fa-twitter" href='https://twitter.com/taekwondonamsan?lang=es' target="_blank"></a>
					<a class="fa fa-instagram" href='https://www.instagram.com/taekwondonamsan/?hl=es' target="_blank"></a>
				</div>
			</h2>
			<h3 class="menu">
				<span class="fa fa-align-justify"></span>
			</h3>
			<div style="clear: both"></div>
		</div>
  <!-- <h3>with Vuex</h3>
		<button @click="setLang('es')">es</button>
		<button @click="setLang('en')">en</button>
		<br /> -->
	</div>
</template>

<script>
// import i18n from "../../lang/lang";
import CONSTANTS from "./constants.js";
import $ from 'jquery'

export default {

  computed: {
    menuOptions() {
      return CONSTANTS.MENU_OPTIONS;
    }
  },

  methods: {
    // setLang: function(lang) {
    //   this.$store.dispatch("setLang", lang);
    // },

    closeNavBar: function() {
      const elem = document.querySelector('.responsive-bar');

      if (getComputedStyle(elem).display === 'block') {
        setTimeout(function() {
          $(".menu").click();
          window.scrollTo(0,0);
        }, 500);
      }
    }
  },

  created: function() {
    $(document).ready(function() {
      $(".menu").click(function() {
        $("nav").slideToggle(500);
      });
    });
  }
};
</script>

<style>
.navbar {
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 0;
}

.logoNamSan {
  background-image: url('~@/assets/logos/favicon.png');
  background-size: cover;
  height: 33px;
  padding: 0px 16px;
  margin-right: 10px;
  vertical-align: bottom;
}
.align-icon {
  display: inline-block;
}

nav {
  width: 100%;
  background: #303f9f;
  padding: 0 20px;
  box-sizing: border-box;
}

.responsive-bar {
  width: 100%;
  background: #303f9f;
  padding: 10px 10px;
  box-sizing: border-box;
  display: none;
}

nav h1 {
  margin: 0;
  padding: 10px 10px;
  float: left;
}

nav h1 a {
  color: #fff;
  text-decoration: none;
  margin-right: 10px;
  margin-left: 10px;
}

nav ul {
  margin: 0;
  padding: 0;
  float: right;
}

nav ul li {
  list-style: none;
  display: inline-block;
  padding: 15px 30px;
  transition: 0.5s;
}

nav ul li a {
  color: #fff;
  text-decoration: none;
}

nav ul li:hover {
  background: #ff5252;
}



.responsive-bar h2 {
  margin: 10px 0 0 0px;
  padding: 3px 0;
  color: #fff;
  float: left;
}

.responsive-bar h2 a {
  color: #fff;
  text-decoration: none;
  margin-right: 10px;
  font-size: 15px;
}

.responsive-bar h3 {
  margin: 20px 0 0 0px;
  width: 25px;
  height: 25px;
  color: #fff;
  float: right;
  background: #303f9f;
  text-transform: uppercase;
}

@media (max-width: 1200px) {
  nav {
    display: none;
    position: absolute;
    top: 60px;
  }
  .responsive-bar {
    display: block;
  }
  nav h1 {
    display: none;
    float: none;
  }
  nav ul {
    float: none;
  }
  nav ul li {
    display: block;
    text-align: right;
    background: #303f9f;
    padding: 15px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
}
</style>
